module.exports = __webpack_public_path__ + "map.svg";